export function createFetchHttpClient(fetchImplementation = fetch) {
  return {
    async get(url) {
      const response = await fetchImplementation(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      return response.json();
    },
  };
}
